import React from "react";
import VideoCard from "../cards/videoCard";

export const ImpactVideos = ({
  gen20YearsOfSustainableImpactTitle,
  firstVid,
  secondVid,
  thirdVid
}) => {
  return (
    <section className="flex justify-center py-10 md:pt-20 md:pb-32 bg-white planet:bg-gray-darkest">
      <div className="w-11/12 md:w-5/6 md:px-7">
        <h1 className="pb-4 md:pb-7 font-normal planet:font-light">
          {gen20YearsOfSustainableImpactTitle}
        </h1>
        <div className="grid grid-cols-2 md:grid-cols-3 grid-rows-2 md:grid-rows-2 gap-2 md:gap-3">
          <div className="col-span-2 row-span-1 md:row-span-2">
            <VideoCard imgSrc={""} featVideos={firstVid} active={true} />
          </div>
          <div className="col-span-1 row-span-1">
            <VideoCard imgSrc={""} featVideos={secondVid} />
          </div>
          <div className="col-span-1 row-span-1">
            <VideoCard imgSrc={""} featVideos={thirdVid} />
          </div>
        </div>
      </div>
    </section>
  );
};
